import { Injectable } from '@angular/core';

@Injectable()
export class LoaderService {

    public isLoading: boolean = false;


    private loadingCount = 0;

    public incrementCount() {
        this.loadingCount++;

        if (this.loadingCount > 0) {
            setTimeout(() => this.isLoading = true);
        }
    }

    public decrementCount() {
        this.loadingCount--;

        if (this.loadingCount === 0) {
            setTimeout(() => this.isLoading = false);
        }
    }
}
